export enum LogIntervalType {
    LogIntervalType_Sec,
    LogIntervalType_Min,
    LogIntervalType_Hrs,
    LogIntervalType_Day,
    LogIntervalType_Mth,
    LogIntervalType_Yrs,
    LogIntervalType_TOTAL,
}

export interface LogConfig {
    type: LogIntervalType;
    value: number;
}

/**
 * Интервал логирования в миллисекундах.
 * @returns число миллисекунд, либо null, если интервал не валидный/не определён
 */
export function logIntervalMs(logConfig: LogConfig | null | undefined): number | null {
    if (!logConfig || logConfig.value <= 0) return null;

    // prettier-ignore
    switch (logConfig.type) {
        case LogIntervalType.LogIntervalType_Sec : return logConfig.value * 1000;
        case LogIntervalType.LogIntervalType_Min : return logConfig.value * 60 * 1000;
        case LogIntervalType.LogIntervalType_Hrs : return logConfig.value * 60 * 60 * 1000;
        case LogIntervalType.LogIntervalType_Day : return logConfig.value * 24 * 60 * 60 * 1000;
        case LogIntervalType.LogIntervalType_Mth : return logConfig.value * 30 * 24 * 60 * 60 * 1000;
        case LogIntervalType.LogIntervalType_Yrs : return logConfig.value * 365 * 24 * 60 * 60 * 1000;
        default                                  : return null; // LogIntervalType_TOTAL — интервал не определён
    }
}

export function logConfigStr(logConfig: LogConfig): string {
    // prettier-ignore
    switch (logConfig.type) {
        case LogIntervalType.LogIntervalType_Sec : return `${logConfig.value} сек.`;
        case LogIntervalType.LogIntervalType_Min : return `${logConfig.value} мин.`;
        case LogIntervalType.LogIntervalType_Hrs : return `${logConfig.value} ч.`;
        case LogIntervalType.LogIntervalType_Day : return `${logConfig.value} дн.`;
        case LogIntervalType.LogIntervalType_Mth : return `${logConfig.value} мес.`;
        case LogIntervalType.LogIntervalType_Yrs : return `${logConfig.value} г.`;
        default: return '';
    }
}
